/* eslint-disable indent */
/* eslint-disable no-unused-vars */

const isObj = require('lodash.get');

export const getAllUsersWithFcmToken = (state) => isObj(state, 'user', []);
export const getAllPushNotificatons = (state) => isObj(state, 'pushNotificatons', []);
